import { IconPen, CloseIcon } from './icons';

interface DraftBannerProps {
  onRestore: () => void;
  onDiscard: () => void;
}

export function DraftBanner({ onRestore, onDiscard }: DraftBannerProps) {
  return (
    <div className="draft-banner">
      <div className="draft-banner-icon"><IconPen size={20} /></div>
      <div className="draft-banner-content">
        <div className="draft-banner-title">Найден черновик</div>
        <div className="draft-banner-subtitle">Продолжить с того места?</div>
      </div>
      <button type="button" className="draft-banner-restore" onClick={onRestore}>
        Восстановить
      </button>
      <button type="button" className="draft-banner-discard" onClick={onDiscard} aria-label="Отмена">
        <CloseIcon size={14} />
      </button>
    </div>
  );
}
